import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { config } from '../../config/appConfig';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
    // Add any base URLs or substrings you want to exclude here
    private excludedUrlPatterns: string[] = [
        config.trackingServiceUrl,
        // 'https://example.com/health',
    ];

    constructor(private loaderService: LoaderService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const shouldSkipLoader = this.excludedUrlPatterns.some(pattern =>
            req.url.includes(pattern)
        );

        if (!shouldSkipLoader) {
            this.loaderService.showLoader();
        }

        return next.handle(req).pipe(
            finalize(() => {
                if (!shouldSkipLoader) {
                    this.loaderService.hideLoader();
                }
            })
        );
    }
}
